// API URL'i (geliştirme ortamında localhost, production'da gerçek sunucu adresi)
export const API_URL = import.meta.env.VITE_API_URL || 'https://new-api.cloudmedia.com.tr/api';

// Base URL (API olmayan istekler için, örneğin ses dosyaları)
export const BASE_URL = API_URL.replace('/api', '');

// WebSocket URL'i
export const WS_URL = import.meta.env.VITE_WS_URL || 'wss://new-api.cloudmedia.com.tr/device';

const parseBooleanEnv = (value: unknown, fallback = false) => {
  if (value === undefined || value === null || value === '') return fallback;
  return String(value).toLowerCase() === 'true';
};

const parseNumberEnv = (value: unknown, fallback: number) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

// Diğer konfigürasyon değerleri
export const CONFIG = {
  // Player ayarları
  player: {
    defaultVolume: 1,
    crossfadeEnabled: parseBooleanEnv(import.meta.env.VITE_ENABLE_CROSSFADE, true),
    crossfadeDuration: Math.min(8, Math.max(2, parseNumberEnv(import.meta.env.VITE_CROSSFADE_DURATION_SECONDS, 4))), // saniye
    bufferTime: 2, // saniye
  },
  
  // Token ayarları
  token: {
    storageKey: 'deviceToken',
    length: 6,
  },
  
  // WebSocket ayarları
  websocket: {
    reconnectInterval: 5000, // ms
    maxReconnectAttempts: 5,
  },
  // Cache ayarları
  cache: {
    maxSize: 100 * 1024 * 1024, // 100 MB
    maxAge: 24 * 60 * 60 * 1000, // 24 saat
  }
} as const;
